<template>
  <form @submit.prevent="login" class="text-left">
    <!-- <img class="mb-4" src="/docs/4.3/assets/brand/bootstrap-solid.svg" alt width="72" height="72" /> -->
    <h1 class="h3 mb-3 font-weight-bold text-uppercase">Sign In</h1>
    <label for="inputUsername" class="text-uppercase mb-0 mt-3">Username</label>
    <input
      type="text"
      id="inputUsername"
      class="form-control"
      placeholder="Username"
      required
      autofocus
      v-model="username"
    />
    <label for="inputPassword" class="text-uppercase mb-0 mt-3">Password</label>
    <input
      type="password"
      id="inputPassword"
      class="form-control"
      placeholder="Password"
      v-model="password"
      required
    />
    <div class="checkbox mb-3">
      <!-- <label>
        <input type="checkbox" value="remember-me" /> Remember me
      </label> -->
    </div>
    <button
      type="submit"
      class="btn btn-lg btn-secondary btn-block text-uppercase"
    >
      Sign In
    </button>
    <p class="w-100 text-center p-2"><a href="https://id.oddular.com/accounts/password/reset/">Forgot Password</a></p>
    <p class="text-danger">{{ error }}</p>

  </form>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  computed: {
    error() {
      return this.$store.state.auth.error;
    }
  },
  methods: {
    login() {
      const { username, password } = this;
      this.$store
        .dispatch("auth/login", { username, password })
        .then(() => this.$router.push("/"));
    }
  }
};
</script>
